import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { User } from "../../shared/classes/signupModel";
import { AuthenticateService } from "../../shared/services/authenticate.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from "ngx-loading";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { CognitoService } from "src/app/shared/services/cognito.service";

@Component({
  selector: "app-sign-up",
  templateUrl: "./sign-up.component.html",
  styleUrls: ["./sign-up.component.sass"],
})
export class SignUpComponent implements OnInit {
  @ViewChild("ngxLoading") ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild("customLoadingTemplate") customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public model: any = {};
  user: User[];
  public loading: boolean;
  globalImgUrl: string;
  signupForm: FormGroup;
  status: string = "";

  constructor(
    private formBuilder: FormBuilder,
    private cognitoService: CognitoService,
    private authService: AuthenticateService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.signupForm = this.formBuilder.group({
      email: ["", Validators.required],
      name: ["", Validators.required],
      phone_number: ["", Validators.required],
      family_name: ["", Validators.required],
    });
  }

  ngDoCheck() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
  }

  restrictAlphabets(e) {
    var x = e.which || e.keycode;
    if ((x >= 48 && x <= 57) || x == 8 || (x >= 35 && x <= 40) || x == 46)
      return true;
    else return false;
  }

  // createUser() {
  //   this.model.family_name = 'apgovt';
  //   this.user = this.model;
  //   console.log("this.model", JSON.stringify(this.model));
  //   console.log("this.model", this.model);
  //   this.authService.createUser(this.model).then((data: any) => {
  //     console.log("user response", data);
  //     if (data.User) {
  //       // console.log("if condition")
  //       Swal({ text: 'Account created successfully' })
  //       this.router.navigate(['/login']);
  //     } else {
  //       // console.log("else condition")
  //       this.status = 'Invalid';
  //       Swal({ text: data.message })
  //     }
  //     this.signupForm.reset();
  //   })
  // }
  createUser() {
    // this.model.family_name = "procurement";
    this.model.password = "Procurement@23";
    this.user = this.model;
    console.log("this.model", JSON.stringify(this.model));
    this.cognitoService.signUp(this.model).then((data: any) => {
      console.log("user response", data);
      if (data.user) {
        this.signupForm = this.formBuilder.group({
          email: ["", [Validators.required, Validators.email]],
          confirmCode: ["", Validators.required],
        });
        this.status = "success";
        // Swal({
        //   text: "Account created successfully.please confirm with code!",
        // });
        // this.router.navigate(["/login"]);
      } else {
        this.status = "Invalid";
        Swal({ text: data.message });
        this.signupForm.reset();
      }
    });
  }

  confirmSignUp() {
    this.loading = true;
    this.cognitoService.confirmSignUp(this.model).then((result: any) => {
      console.log("@@Confirmation sign up response:", result);
      if (result.result == "SUCCESS") {
        Swal({ text: "Account created successfully" });
        this.loading = false;
        this.router.navigate(["/login"]);
      } else {
        Swal({ text: result.message });
        this.loading = false;
      }
    });
  }
}
